import { render } from "./PublicHolidayWidget.vue?vue&type=template&id=43819fca&scoped=true"
import script from "./PublicHolidayWidget.vue?vue&type=script&lang=js"
export * from "./PublicHolidayWidget.vue?vue&type=script&lang=js"

import "./public-holiday-widget.scss?vue&type=style&index=0&id=43819fca&lang=scss&scoped=true&external"
import "./PublicHolidayWidget.vue?vue&type=style&index=1&id=43819fca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43819fca"]])

export default __exports__